
import Network from './network';
// 封装各种接口请求
// export const 接口名 = () => Network.get('/路由',参数对象);
export default {
    // 登录
    login:(data) => Network.post('api/user/login',data),
    // 登录
    mobileLogin:(data) => Network.post('api/user/mobileLogin',data),
    // mac验证mac
    GetUserAuth:(data) => Network.get('api/user/GetUserAuth',data),
   // 获取字段
    GetTableSet:(data) => Network.get('api/Sys_Table_Set/GetTableSet',data),
    // 拖动列宽
    SaveTableSetWidth:(data) => Network.post('api/Sys_Table_Set/SaveTableSetWidth',data),
    // 保存字段
    SaveTableSet:(data) => Network.post('api/Sys_Table_Set/SaveTableSet',data),
    // 权限导航
    getTreeMenu:(data) => Network.get('api/menu/getTreeMenu',data),

    // 计价单位查询
    GetUnitList:(data) => Network.get('api/Sys_Purveyor_Price/GetUnitList',data),

    // 获取省市区
    getDistrictById:(data) => Network.get('api/District/GetDistrict',data),
    GetDistrictTree:(data) => Network.get('api/District/GetDistrict',data),
    // 上传供应商图片
    UploadPurveyor:(data) => Network.post('api/Sys_Purveyor/Upload',data),
    // 供应商查询
    GetPurveyorData:(data) => Network.get('api/Sys_Purveyor/GetPurveyorData',data),
    // 供应商管理
    getPurveyor:(data) => Network.post('api/Sys_Purveyor/getPageData',data),
	// 确认切换供应商
	SwitchSupplier:(data) => Network.post('api/purchase/SwitchSupplier',data),
    GetPurveyorInfoGys:(data) => Network.get('api/Sys_Purveyor/GetPurveyorInfo',data),
    // 交期信息
    getPurveyorJQ:(data) => Network.post('api/Sys_Purchase_Delivery/GetPageData',data),
    // 下拉档案
    GetVueDictionary:(data) => Network.post('api/Sys_Dictionary/GetVueDictionary',data),
    // 附件管理
    getFileList:(data) => Network.post('api/Sys_Purveyor_File/getPageData',data),
    addFileList:(data) => Network.post('api/Sys_Purveyor_File/Add',data),
    PurveyorDownFile:(data) => Network.post('api/Sys_Purveyor_File/DownFile',data),
    Purveyor_File_Log:(data) => Network.post('api/Sys_Purveyor_File_Log/getPageData',data),
    UploadFile:(data) => Network.post('api/Sys_Purveyor_File/UploadFile',data),
    DelUploadFile:(data) => Network.post('api/Sys_Purveyor_File/Del',data),

    editPurveyor:(data) => Network.post('api/Sys_Purveyor/Update',data),
    AddPurveyor:(data) => Network.post('api/Sys_Purveyor/Add',data),
    delPurveyor:(data) => Network.post('api/Sys_Purveyor/del',data),
    // 供应商等级下拉（直连 Sys_Purveyor_Grade，不走字典）
    getPurveyorGradeList:(data) => Network.post('api/Sys_Purveyor_Grade/getPageData',data),
    // 商品等级下拉（直连 Sys_Prdt_Grade，不走字典）
    getPrdtGradeList:(data) => Network.post('api/Sys_Prdt_Grade/getPageData',data),
    // 产品类型商品等级维护
    getPrdtTypeGradePage:(data) => Network.post('api/SysPrdtController/GetPrdtTypeGradePage',data),
    // 采购BOM列表（万里牛同步）
    getWlnPurchaseBom:(data) => Network.post('api/Sys_WlnPurchaseBom/getPageData',data),
    // 采购BOM子件明细（万里牛同步）
    getWlnPurchaseBomItem:(data) => Network.post('api/Sys_WlnPurchaseBomItem/getPageData',data),
    // 产品类型商品等级维护-批量修改（单条=Ids只传一个；null=不修改该项）
    batchUpdatePrdtTypeGrade:(data) => Network.post('api/SysPrdtController/BatchUpdatePrdtTypeGrade',data),
    // 产品类型商品等级维护-修改日志
    getPrdtTypeGradeLog:(data) => Network.post('api/SysPrdtController/GetPrdtTypeGradeLog',data),
    // 供应商档案 导入/导出/模板/批量改等级
    ImportPurveyor:(data) => Network.post('api/Sys_Purveyor/Import',data),
    ExportPurveyor:(data) => Network.post('api/Sys_Purveyor/Export',data),
    DownLoadPurveyor:() => Network.get('api/Sys_Purveyor/DownLoad'),
    BatchUpdatePurveyorGrade:(data) => Network.post('api/Sys_Purveyor/BatchUpdateGrade',data),
    //下载导入Excel模板
    DownloadPurchaseImportTemplate:(data) => Network.get('api/Purchase/Prdt/DownloadImportTemplate',data),
    //导入表数据Excel文件夹
    ImportPurchaseTasksFromExcel:(data) => Network.post('api/Purchase/Prdt/ImportTasksFromExcel',data),

    // 获取供应商
    GetPrdtPurveyorList:(data) => Network.get('api/Purchase/Prdt/GetPurveyorList',data),
    // 批量更新供应商 任务栏
    PrdtBatchUpdatePurveyor:(data) => Network.post('api/Purchase/Prdt/BatchUpdatePurveyor',data),
    // 批量更新供应商 购物车
    BatchUpdatePurveyor:(data) => Network.post('api/purchase/BatchUpdatePurveyor',data),

    // 供应商价目表
    getPurveyorInfo:(data) => Network.post('api/Sys_Purveyor_Info/getPageData',data),
	//价格管控表
	getPurveyorPriceReport:(data) => Network.get('api/Sys_Purveyor_Price/GetPurveyorPriceReport',data),
    // 新增供应商价目表
    AddPurveyorInfo:(data) => Network.post('api/Sys_Purveyor_Info/Add',data),
    // 编辑供应商价目表
    updatePurveyorInfo:(data) => Network.post('api/Sys_Purveyor_Info/update',data),
    // 删除供应商价目表
    delPurveyorInfo:(data) => Network.post('api/Sys_Purveyor_Info/del',data),
    // 统一调价
    BatchUpdateDiscount:(data) => Network.post('api/Sys_Purveyor_Price/BatchUpdateDiscount',data),
    // 批量价格更新（勾选价目表更新价格，不勾选为全部）
    BatchUpdatePrice:(data) => Network.post('api/Sys_Purveyor_Price/BatchUpdatePrice',data),
    // 个人中心-价目表列表-移交负责人
    UpdateManagerInfo:(data) => Network.post('api/Sys_Purveyor_Info/UpdateManager',data),
    // 个人中心-价目表列表-移交负责人校验
    UpdateManagerCheckInfo:(data) => Network.post('api/Sys_Purveyor_Info/UpdateManagerCheck',data),
    // 个人中心-价目表-移交负责人
    UpdateManager:(data) => Network.post('api/Sys_Purveyor_Price/UpdateManager',data),
    // 个人中心-价目表-移交负责人校验
    UpdateManagerCheck:(data) => Network.post('api/Sys_Purveyor_Price/UpdateManagerCheck',data),

    // 供应商价目表修改历史
    getPurveyorLogInfo:(data) => Network.post('api/Sys_Purveyor_Log_Info/GetPageData',data),
    // 供应商价目表修改历史详细
    getPurveyorPriceLog:(data) => Network.post('api/Sys_Purveyor_Price_Log/GetPageData',data),

    // 供应商价目表维护
    getPurveyorPrice:(data) => Network.post('api/Sys_Purveyor_Price/getPageData',data),
    // 供应商价目表维护 导入
    ImportPurveyorPrice:(data) => Network.post('api/Sys_Purveyor_Price/Import',data),
    ExportPurveyorPrice:(data) => Network.post('api/Sys_Purveyor_Price/Export',data),
	ExportPurveyorPriceReport:(data) => Network.post('api/Sys_Purveyor_Price/ExportPurveyorPriceReport',data),
	GetPurveyorPriceReportLog:(data) => Network.get('api/Sys_Purveyor_Price/GetPurveyorPriceReportLog',data),
    DownLoad:(data) => Network.get('api/Sys_Purveyor_Price/DownLoad',data),
	DownloadPackageTemplate:(data) => Network.post('api/Sys_Purveyor_Price/DownloadPackageTemplate',data),

    //根据商品编码获取商品信息
    GetPrdtListPurveyorPrice:(data) => Network.post('api/Sys_Purveyor_Price/GetPrdtList ',data),
    // 商品分类档案
    GetItemCategoryList:(data) => Network.get('api/Sys_Purveyor_Price/GetItemCategoryList',data),
    //保存价目表 
    SavePurveyorPrice:(data) => Network.post('api/Sys_Purveyor_Price/Save ',data),
    //新增 保存价目表 
    AddSave:(data) => Network.post('api/Sys_Purveyor_Price/AddSave ',data),
    //删除价目表 
    DelPurveyorPrice:(data) => Network.post('api/Sys_Purveyor_Price/Del ',data),

    //计价单位 
    getPacking:(data) => Network.post('api/Sys_Packing/getPageData ',data),
    //税率 
    getTaxRate:(data) => Network.post('api/Sys_Tax_Rate/getPageData ',data),



    // 供应商类别
    getPurveyorCategory:(data) => Network.post('api/Sys_Purveyor_Category/getPageData',data),
    // 新增供应商类别
    addPurveyorCategory:(data) => Network.post('api/Sys_Purveyor_Category/Add',data),
    // 删除供应商类别
    delPurveyorCategory:(data) => Network.post('api/Sys_Purveyor_Category/del',data),
    // 编辑供应商类别
    updatePurveyorCategory:(data) => Network.post('api/Sys_Purveyor_Category/update',data),

    // 暂停合作
    getSuspend:(data) => Network.post('api/Sys_Suspend/getPageData',data),
    // 新增暂停合作
    addSuspend:(data) => Network.post('api/Sys_Suspend/Add',data),
    // 删除暂停合作
    delSuspend:(data) => Network.post('api/Sys_Suspend/del',data),
    // 编辑暂停合作
    updateSuspend:(data) => Network.post('api/Sys_Suspend/update',data),

    // 检验级别
    getInspectionLevel:(data) => Network.post('api/Sys_Inspection_Level/getPageData',data),
    // 新增检验级别
    addInspectionLevel:(data) => Network.post('api/Sys_Inspection_Level/Add',data),
    // 删除检验级别
    delInspectionLevel:(data) => Network.post('api/Sys_Inspection_Level/del',data),
    updateInspectionLevel:(data) => Network.post('api/Sys_Inspection_Level/update',data),

    // 税率档案
    getTaxRate:(data) => Network.post('api/Sys_Tax_Rate/getPageData',data),
    // 新增税率档案
    addTaxRate:(data) => Network.post('api/Sys_Tax_Rate/Add',data),
    // 删除税率档案
    delTaxRate:(data) => Network.post('api/Sys_Tax_Rate/del',data),
    updateTaxRate:(data) => Network.post('api/Sys_Tax_Rate/update',data),

    // 签约方式
    getSigningMethod:(data) => Network.post('api/Sys_Signing_Method/getPageData',data),
    // 新增签约方式
    addSigningMethod:(data) => Network.post('api/Sys_Signing_Method/Add',data),
    // 删除签约方式
    delSigningMethod:(data) => Network.post('api/Sys_Signing_Method/del',data),
    updateSigningMethod:(data) => Network.post('api/Sys_Signing_Method/update',data),

    // 采购财务退回原因
    getBackReason:(data) => Network.post('api/Sys_Purchase_Back_Reason/getPageData',data),
    // 新增退回原因
    addBackReason:(data) => Network.post('api/Sys_Purchase_Back_Reason/Add',data),
    // 删除退回原因
    delBackReason:(data) => Network.post('api/Sys_Purchase_Back_Reason/del',data),
    updateBackReason:(data) => Network.post('api/Sys_Purchase_Back_Reason/update',data),

    // 仓库列表
    GetStockList:(data) => Network.get('api/purchase/GetStockList',data),
    // 获取价目表信息 产品列表
    GetPrdtListpurchase:(data) => Network.post('api/purchase/GetPrdtList',data),
    // 新增购物车
    addCart:(data) => Network.post('api/purchase/AddCart',data),
    // 购物车数据查询
    getCartPrdtList:(data) => Network.get('api/purchase/GetCartPrdtList',data),
    // 修改购物车数量
    UpdateCartQty:(data) => Network.post('api/purchase/UpdateCartQty',data),
    // 修改购物车选中状态
    UpdateCartCheck:(data) => Network.post('api/purchase/UpdateCartCheck',data),
    // 删除购物车数据
    DeleteCart:(data) => Network.post('api/purchase/DeleteCart',data),
    // 获取供应商
    GetPurveyorList:(data) => Network.get('api/purchase/GetPurveyorList',data),
    // 获取其他供应商价目表
    GetPurveyorPrdtList:(data) => Network.get('api/purchase/GetPurveyorPrdtList',data),
    // 更换供应商
    UpdateCartPurveyor:(data) => Network.post('api/purchase/UpdateCartPurveyor',data),
    // 初始化供应商档案
    InitPurveyor:(data) => Network.get('api/Sys_Purveyor/InitPurveyor',data),
    // 同步万里牛商品
    SyncWlnPrdt:() => Network.get('api/WlnSync/SyncWlnPrdt'),
    // 按规格编码同步万里牛商品（多个编码用英文逗号分隔）
    SyncWlnPrdtBySpec:(specNos) => Network.get('api/WlnSync/SyncWlnPrdtBySpec',{specNos:specNos}),
	// 更新价格
	updatePurveyorPrice:(data) => Network.post('api/Sys_Purveyor/updatePurveyorPrice',data),
    //批量加入购物车
    BachAddCart:(data) => Network.post('api/purchase/BachAddCart',data),
    // 获取购物车产品个数
    getCartNum:(data) => Network.get('api/purchase/GetCartNum',data),

    // 按供应商----商品分类
    GetCategoryForPurveyor:(data) => Network.get('api/Purchase/Prdt/GetCategoryForPurveyor',data),
    // 商品列表----按供应商
    GetPrdtListForPurveyor:(data) => Network.get('api/Purchase/Prdt/GetPrdtListForPurveyor',data),
    // 产品属性--按供应商
    GetPrdtBaseInfoForPurveyor:(data) => Network.get('api/Purchase/Prdt/GetPrdtBaseInfoForPurveyor',data),

    // 商品分类
    GetCategory:(data) => Network.get('api/Purchase/Prdt/GetCategory',data),
    // 商品分类 导航进入查询
    GetCategoryData:(data) => Network.get('api/Purchase/Prdt/GetCategoryData',data),
    // 产品属性--导航进入查询
    GetBaseInfoByCategory:(data) => Network.get('api/Purchase/Prdt/GetBaseInfoByCategory',data),
    // 商品列表----导航进入查询
    GetPrdtByCategory:(data) => Network.get('api/Purchase/Prdt/GetPrdtByCategory',data),
    // 产品属性--日常补货页面
    GetPrdtBaseInfo:(data) => Network.get('api/Purchase/Prdt/GetPrdtBaseInfo',data),
    // 商品列表----日常补货页面
    GetPrdtList:(data) => Network.get('api/Purchase/Prdt/GetPrdtList',data),
    // 商品列表----预警表页面
    GetPrdtListNew:(data) => Network.get('api/Purchase/Prdt/GetPrdtListNew',data),
    // 预警/缺货处理页----商品分类多选下拉选项（按用户分类权限过滤）
    GetItemCategoryOptions:(data) => Network.get('api/Purchase/Prdt/GetItemCategoryOptions',data),
	// 商品列表----审批预警表页面
    GetPendingApplyList:(data) => Network.get('api/Purchase/Prdt/GetPendingApplyList',data),
	// 商品列表----缺货待审批申请列表（独立审批，读缺货表）
    GetPendingLackApplyList:(data) => Network.get('api/Purchase/Prdt/GetPendingLackApplyList',data),
	// 预警申请提交
    ApplyWarning:(data) => Network.post('api/purchase/ApplyWarning',data),
	// 采购用户列表
    GetPurchaseUserList:(data) => Network.get('api/purchase/GetPurchaseUserList',data),
	// 缺货预警分配处理人
    AssignHandler:(data) => Network.post('api/purchase/AssignHandler',data),
	// 缺货主管分配处理人
	AssignLackHandler:(data) => Network.post('api/purchase/AssignLackHandler',data),
	// 缺货主管分配到货仓
	AssignArrivalWarehouse:(data) => Network.post('api/purchase/AssignArrivalWarehouse',data),
	// 缺货预警审批
	ApproveApply:(data) => Network.post('api/purchase/ApproveApply',data),
	// 缺货申请审批（独立接口，写缺货表）
	ApproveLackApply:(data) => Network.post('api/purchase/ApproveLackApply',data),
	// 采购员--批量提交采购订单
	BatchSubmitOrder:(data) => Network.post('api/Purchase/Order/BatchSubmitOrder',data),
	// 按筛选条件一键生成采购草稿
	BatchSubmitOrderCondition:(data) => Network.post('api/Purchase/Order/BatchSubmitOrderCondition',data),
	// 外部已处理延迟显示标记
    ToggleLackExternallyProcessed:(data) => Network.post('api/purchase/ToggleLackExternallyProcessed',data),
	// 商品列表----缺货预警表页面
    GetPrdtListLack:(data) => Network.get('api/Purchase/Prdt/GetPrdtListLack',data),
	// 商品列表----缺货主管表页面
    GetPrdtListByLackLog:(data) => Network.get('api/Purchase/Prdt/GetPrdtListByLackLog',data),
	// 缺货主管表页面----分配处理人清空
	ClearLackAssignee:(data) => Network.post('api/purchase/ClearLackAssignee',data),
	// 缺货主管表页面----商品已处理（已恢复）缺货记录分页（关联已处理预警弹窗）
	GetProcessedLackList:(data) => Network.get('api/purchase/GetProcessedLackList',data),
	// 缺货主管表页面----关联已处理预警（当前记录标已恢复，历史记录重新激活）
	RelateProcessedLack:(data) => Network.post('api/purchase/RelateProcessedLack',data),
	
	// 导出----预警表页面
    ExportWarning:(data) => Network.post('api/Purchase/Prdt/ExportWarning',data),
    // 导出----预警处理表页面（含审批相关列）
    ExportWarningHandle:(data) => Network.post('api/Purchase/Prdt/ExportWarningHandle',data),
    // 导出----缺货申请处理（warnHandleTable cat-2，走缺货表，含审批相关列）
    ExportWarningLack:(data) => Network.post('api/Purchase/Prdt/ExportWarningLack',data),
	// 导出----缺货预警表页面
    ExportLack:(data) => Network.post('api/Purchase/Prdt/ExportLack',data),
    //导出
    Export:(data) => Network.post('api/Purchase/Prdt/Export',data),
    ExporDaily:(data) => Network.post('api/Purchase/Prdt/ExporDaily',data),
    // 历史采购记录查询----日常补货页面
    GetBuyOrderPrdtList:(data) => Network.get('api/purchase/GetBuyOrderPrdtList',data),

    // 产品属性---缺货补货页面
    GetPrdtBaseInfoNotQty:(data) => Network.get('api/Purchase/Prdt/GetPrdtBaseInfoNotQty',data),

    // 商品列表-----缺货补货页面
    GetPrdtNotQtyList:(data) => Network.get('api/Purchase/Prdt/GetPrdtNotQtyList',data),
    // 导出-----缺货补货页面
    ExportNotQty:(data) => Network.post('api/Purchase/Prdt/ExportNotQty',data),

    // 单个加入采购任务
    AddTask:(data) => Network.post('api/Purchase/Prdt/AddTask',data),
    // 当前页加入采购任务
    BachAddTask:(data) => Network.post('api/Purchase/Prdt/BachAddTask',data),
    // 一键加入采购任务
    BachAddTaskCondition:(data) => Network.post('api/Purchase/Prdt/BachAddTaskCondition',data),

    // 采购任务----查询
    GetTaskPrdtList:(data) => Network.get('api/Purchase/Prdt/GetTaskPrdtList',data),
    // 采购任务---- 修改数量
    UpdateTaskQty:(data) => Network.post('api/Purchase/Prdt/UpdateTaskQty',data),
    // 采购任务---- 修改选中状态
    UpdateTaskCheck:(data) => Network.post('api/Purchase/Prdt/UpdateTaskCheck',data),
    // 采购任务---- 更换供应商
    UpdateTaskPurveyor:(data) => Network.post('api/Purchase/Prdt/UpdateTaskPurveyor',data),
    // 采购任务---- 删除
    DeleteTask:(data) => Network.post('api/Purchase/Prdt/DeleteTask',data),

    // 查询结算 
    GetSettlePrdtList:(data) => Network.get('api/purchase/GetSettlePrdtList',data),
    //地址识别
    GetAddressSplit:(data) => Network.get('api/purchase/GetAddressSplit',data),
    // 提交订单
    SubmitOrder:(data) => Network.post('api/Purchase/Order/SubmitOrder',data),
    // 提交委外订单
    SubmitOrderOut:(data) => Network.post('api/Outsource/Order/SubmitOrder',data),
    //下载Excel
    ExportError:(data) => Network.post('api/Sys_Purveyor_Price/ExportError',data),

    //生成询价单=============
    // 生成图片并保存报价单
    SaveQuotation:(data) => Network.post('api/Quotation/SaveQuotation',data),
    // 导出文件，返回日期+文件名
    exportQuotation:(data) => Network.post('api/Quotation/ExportQuotation',data),
    // 下载图片
    downLoadImg:(data) => Network.post('api/Quotation/DownLoadImg',data),
    // 下载Excel
    downLoadExcel:(data) => Network.post('api/Quotation/DownLoadExcel',data),
    // 获取用户报价单
    getQuotationList:(data) => Network.get('api/Quotation/GetQuotationList',data),
    // 获取用户报价单详情
    getQuotationDetail:(data) => Network.get('api/Quotation/GetQuotationDetail',data),


    // 个人中心左侧菜单数量
    GetMenuNum:(data) => Network.get('api/Purchase/Order/GetMenuNum',data),
    // 订单状态
    GetStatusNum:(data) => Network.get('api/Purchase/Order/GetStatusNum',data),
    // 日志
    sys_purchase_order_log:(data) => Network.post('api/sys_purchase_order_log/getPageData',data),
    // 订单列表
    getOrderList:(data) => Network.get('api/Purchase/Order/GetBuyerOrders',data),
    // 订单导出
    OrderExport:(data) => Network.get('api/Purchase/Order/Export',data),
    // 财务确认列表
    GetBuyerOrdersFinanceSure:(data) => Network.get('api/Purchase/Order/GetBuyerOrdersFinanceSure',data),
    // 财务付款列表
    GetBuyerOrdersFinancePay:(data) => Network.get('api/Purchase/Order/GetBuyerOrdersFinancePay',data),
    // 财务退款列表
    GetBuyerOrdersFinanceReturnPay:(data) => Network.get('api/Purchase/Order/GetBuyerOrdersFinanceReturnPay',data),
    // 超期订单
    GetBuyerOrdersOverdue:(data) => Network.get('api/Purchase/Order/GetBuyerOrdersOverdue',data),
    // 财务确认
    FinanceSureOrder:(data) => Network.post('api/Purchase/Order/FinanceSureOrder',data),
    // 财务撤回
    FinanceBackOrder:(data) => Network.post('api/Purchase/Order/FinanceBackOrder',data),
    // 财务退回原因下拉
    GetPurchaseBackReasonList:(data) => Network.get('api/Purchase/Order/GetPurchaseBackReasonList',data),
    // 财务付款 撤回
    FinancePayBackOrder:(data) => Network.post('api/Purchase/Order/FinancePayBackOrder',data),

    // 成本调整确认列表
    CostPriceLogPageData:(data) => Network.get('api/Sys_Prdt_CostPrice_Log/GetPageData',data),
    // 成本调整待确认数量
    CostPriceLogPendingCount:() => Network.get('api/Sys_Prdt_CostPrice_Log/GetPendingCount'),
    // 成本调整确认人下拉
    CostPriceLogConfirmUsers:() => Network.get('api/Sys_Prdt_CostPrice_Log/GetConfirmUsers'),
    // 成本调整确认
    CostPriceLogConfirm:(data) => Network.post('api/Sys_Prdt_CostPrice_Log/Confirm',data),
    // 成本调整批量确认
    CostPriceLogConfirmBatch:(data) => Network.post('api/Sys_Prdt_CostPrice_Log/ConfirmBatch',data),
    // 成本调整驳回
    CostPriceLogReject:(data) => Network.post('api/Sys_Prdt_CostPrice_Log/Reject',data),
    // 成本调整批量驳回
    CostPriceLogRejectBatch:(data) => Network.post('api/Sys_Prdt_CostPrice_Log/RejectBatch',data),

    // 价差审核列表（采购订单提交时价格与价目表不一致的放行记录）
    PriceDiffLogPageData:(data) => Network.get('api/Sys_Purchase_PriceDiff_Log/GetPageData',data),
    // 价差待处理数量
    PriceDiffLogPendingCount:() => Network.get('api/Sys_Purchase_PriceDiff_Log/GetPendingCount'),
    // 价差处理人下拉选项
    PriceDiffLogHandlers:() => Network.get('api/Sys_Purchase_PriceDiff_Log/GetHandlers'),
    // 价差记录标记已处理
    PriceDiffLogHandle:(data) => Network.post('api/Sys_Purchase_PriceDiff_Log/Handle',data),
    
    // 财务关闭审核列表
    GetBuyerOrdersFinanceClose:(data) => Network.get('api/Purchase/Order/GetBuyerOrdersFinanceClose',data),
    // 个人中心-采购订单-关闭审核通过
    PurchaseCloseOrderAudit:(data) => Network.post('api/Purchase/Order/CloseOrderAudit',data),
    // 个人中心-采购订单-关闭审核撤回
    PurchaseCloseOrderBack:(data) => Network.post('api/Purchase/Order/CloseOrderBack',data),
    // 个人中心-采购订单-提交关闭申请
    // PurchaseCloseOrder:(data) => Network.post('api/Purchase/Order/CloseOrder',data),

    // 订单明细
    getOrdersDetails:(data) => Network.get('api/Purchase/Order/GetBuyerOrderInfo',data),
    // 复制订单 订单明细
    getOrdersDetailsCopy:(data) => Network.get('api/Purchase/Order/CopyOrder',data),
    // 同步状态
    AsyncOrderStatus:(data) => Network.get('api/Purchase/Order/AsyncOrderStatus',data),
    // 订单取消
    cancelOrder:(data) => Network.post('api/Purchase/Order/CancelOrder',data),
    // 个人中心-采购订单-提交关闭申请
    closeOrder:(data) => Network.post('api/Purchase/Order/CloseOrder',data),
    // 同步畅捷通
    SyncCjt:(data) => Network.post('api/Purchase/Order/SyncCjt',data),
    // 批量同步畅捷通（按当前日期筛选，仅未同步，不重推）
    SyncCjtBatch:(data) => Network.post('api/Purchase/Order/SyncCjtBatch',data),
    // 确认订单
    sureOrder:(data) => Network.post('api/Purchase/Order/SureOrder',data),
    //再次  确认订单
    AgainSure:(data) => Network.post('api/Purchase/Order/AgainSure',data),
    // 确认付款
    SureOrderPay:(data) => Network.post('api/Purchase/Order/SureOrderPay',data),
    // 确认通知
    SureOrderNotice:(data) => Network.post('api/Purchase/Order/SureOrderNotice',data),
    // 订单取消
    CancelOrder:(data) => Network.post('api/Purchase/Order/CancelOrder',data),
    // 退款取消
    ReturnPayCancelOrder:(data) => Network.post('api/Purchase/Order/ReturnPayCancelOrder',data),
    // 确认退款
    SureReturnPay:(data) => Network.post('api/Purchase/Order/SureReturnPay',data),
    // 修改仓库
    UpdateOrderStock:(data) => Network.post('api/Purchase/Order/UpdateOrderStock',data),
    // 修改外部单号
    UpdateOrderExternalNo:(data) => Network.post('api/Purchase/Order/UpdateOrderExternalNo',data),
    // 再来一单
    BuyAgain:(data) => Network.get('api/Purchase/Order/BuyAgain',data),
    // 上传凭证
    UploadPurchase:(data) => Network.post('api/Sys_Purchase_Order/Upload',data),

    // 采购任务池
    GetDataPage:(data) => Network.get('api/View_Bill_Buy_Item/GetDataPage',data),
    // 入库仓库
    getPageDataStock:(data) => Network.post('api/Sys_Stock/getPageData',data),
    // 分支机构
    getPageDataStype:(data) => Network.post('api/Sys_Stype/getPageData',data),
    // 采购任务池 查询产品
    GetBuyPrdtList:(data) => Network.post('api/purchase/GetBuyPrdtList',data),
    // 获取超时任务数据
    GetOvertimeList:(data) => Network.get('api/purchase/GetOvertimeList',data),
    // 预警/缺货记录
    GetPrdtLogList:(data) => Network.get('api/purchase/GetPrdtLogList',data),

    // 新增采购订单
    // 根据供应商和仓库获取交期
    GetEstDate:(data) => Network.get('api/Purchase/Order/GetEstDate',data),
    // 分支机构
    GetStypeList:(data) => Network.get('api/Purchase/Order/GetStypeList',data),
     // 入库仓库
     GetStockListOrder:(data) => Network.get('api/Purchase/Order/GetStockList',data),
    // 供应商档案
    GetPurveyorListOrder:(data) => Network.get('api/Purchase/Order/GetPurveyorList',data),
    // 供应商简表
    GetPurveyorSimpleList:(data) => Network.get('api/Purchase/Order/GetPurveyorSimpleList',data),
    // 获取商品信息
    GetPrdtListOrder:(data) => Network.post('api/Purchase/Order/GetPrdtList',data),
    // 联动采购商品
    GetLinkageBuyProducts:(data) => Network.get('api/Purchase/Prdt/GetLinkageBuyProducts',data),
    // 弹框 单选 获取商品信息
    getPageDataPrdt:(data) => Network.post('api/Sys_Prdt/GetPageDataForEs',data),
    // 弹框 多选 获取商品信息
    GetPageDataForEsDialog:(data) => Network.post('api/Sys_Prdt/GetPageDataForEsDialog',data),
    // 弹框 树形
    getTreeData:(data) => Network.get('api/SysPrdtController/GetItemCategoryList',data),
    // 弹框 筛选条件
    GetPrdtBaseInfoForPop:(data) => Network.post('api/Sys_Prdt/GetPrdtBaseInfo',data),
    // 相似订单查询
    SimilarityOrder:(data) => Network.post('api/Purchase/Order/SimilarityOrder',data),
    // 保存草稿
    SaveOrder:(data) => Network.post('api/Purchase/Order/SaveOrder',data),
    // 删除
    DelPrdt:(data) => Network.post('api/Purchase/Order/DelPrdt',data),
    // 提交订单
    SubmitBuyOrder:(data) => Network.post('api/Purchase/Order/SubmitBuyOrder',data),
    // 个人中心-采购订单 保存外部单号，外部单号备注，订单备注，议价修改
    UpdateOrder:(data) => Network.post('api/Purchase/Order/UpdateOrder',data),
    // 复制订单
    CopyOrder:(data) => Network.get('api/Purchase/Order/CopyOrder',data),
    // 分单：选中明细迁出生成新单（新单为待采购确认，前端再串 sureOrder 推进到待财务复核）
    SplitOrder:(data) => Network.post('api/Purchase/Order/SplitOrder',data),
    // 合单：源单明细并入目标单，目标单保留单号，源单作废（前端再串 sureOrder 推进到待财务复核）
    MergeOrder:(data) => Network.post('api/Purchase/Order/MergeOrder',data),
    // 合单候选订单：与本单同仓库+供应商+制单人且同为待采购确认的其它订单（跨页）
    getMergeCandidates:(data) => Network.get('api/Purchase/Order/GetMergeCandidates',data),

    // 草稿购物车：明细懒加载（卡片点"展开"后才请求）
    GetDraftDetailList:(data) => Network.get('api/Purchase/Order/GetDraftDetailList',data),
    // 草稿购物车：明细改数量（步进器）
    UpdateDraftDetailQty:(data) => Network.post('api/Purchase/Order/UpdateDraftDetailQty',data),
    // 草稿购物车：明细改草稿备注（独立字段，不共用订单明细备注）
    UpdateDraftDetailRemark:(data) => Network.post('api/Purchase/Order/UpdateDraftDetailRemark',data),
    // 草稿购物车：明细勾选/取消勾选持久化（DetailIds 空数组=整单全部）
    UpdateDraftDetailCheck:(data) => Network.post('api/Purchase/Order/UpdateDraftDetailCheck',data),
    // 草稿购物车：更换供应商（单个/批量统一，明细迁到目标供应商草稿并按其价目表重算）
    UpdateDraftPurveyor:(data) => Network.post('api/Purchase/Order/UpdateDraftPurveyor',data),
    // 草稿购物车：联动加入商品（只传商品+数量，价格服务端按当前价目表解析后直接落库草稿）
    AddDraftDetails:(data) => Network.post('api/Purchase/Order/AddDraftDetails',data),
    // 草稿购物车：明细按商品编码手动重排（重编 SortNum，列表/发送顺序变为编码序）
    ResortDraftDetails:(data) => Network.post('api/Purchase/Order/ResortDraftDetails',data),
    // 待采购确认详情：标记供应商缺货等待（预计到货时间+倒计时）
    SetOrderLackWait:(data) => Network.post('api/Purchase/Order/SetOrderLackWait',data),
    // 待采购确认详情：撤回草稿（选中明细并入对应供应商草稿，原因必填）
    BackToDraft:(data) => Network.post('api/Purchase/Order/BackToDraft',data),
    // 撤回草稿原因历史（当前用户，PascalCase 返回）
    GetDraftBackReasonList:(data) => Network.get('api/Purchase/Order/GetDraftBackReasonList',data),

    // 下载中心
    GetListDownload:(data) => Network.get('api/Sys_Download/GetList',data),
    // 头部下载中心
    GetDayList:(data) => Network.get('api/Sys_Download/GetDayList',data),
    // 删除
    DelDownload:(data) => Network.post('api/Sys_Download/Del',data),
    


    //委外订单
    // 个人中心左侧菜单数量
    GetMenuNumOut:(data) => Network.get('api/Outsource/Order/GetMenuNum',data),
    // 加工项目档案
    getWorkingItema:(data) => Network.post('/api/Sys_Working_Item/getPageData',data),
    // 加工要求档案
    getWorkingRequire:(data) => Network.post('/api/Sys_Working_Require/getPageData',data),
    // 根据供应商和仓库获取交期
    GetEstDateOut:(data) => Network.get('api/Outsource/Order/GetEstDate',data),
    // 分支机构
    GetStypeListOut:(data) => Network.get('api/Outsource/Order/GetStypeList',data),
     // 入库仓库
     GetStockListOrderOut:(data) => Network.get('api/Outsource/Order/GetStockList',data),
    // 获取采购订单
    GetPourchaseOrderListOut:(data) => Network.get('/api/Outsource/Order/GetPourchaseOrderList',data),
    // 供应商档案
    GetPurveyorListOrderOut:(data) => Network.get('api/Outsource/Order/GetPurveyorList',data),
    // 获取商品信息
    GetPrdtListOrderOut:(data) => Network.post('api/Outsource/Order/GetPrdtList',data),
    // 相似订单查询
    SimilarityOrderOut:(data) => Network.post('api/Outsource/Order/SimilarityOrder',data),
    // 保存草稿
    SaveOrderOut:(data) => Network.post('api/Outsource/Order/SaveOrder',data),
    // 删除
    DelPrdtOut:(data) => Network.post('api/Outsource/Order/DelPrdt',data),
    // 提交订单
    SubmitBuyOrderOut:(data) => Network.post('api/Outsource/Order/SubmitBuyOrder',data),
    // 个人中心-委外加工单-委外发料
    MaterialSaveOrder:(data) => Network.post('api/Material/Order/SaveOrder',data),
    // 个人中心-委外加工单-委外入库
    WarehousingSaveOrder:(data) => Network.post('api/Warehousing/Order/SaveOrder',data),
    // 个人中心-采购订单 保存外部单号，外部单号备注，订单备注，议价修改
    UpdateOrderOut:(data) => Network.post('api/Outsource/Order/UpdateOrder',data),
    // 复制订单
    CopyOrderOut:(data) => Network.get('api/Outsource/Order/CopyOrder',data),
    // 订单状态
    GetStatusNumOut:(data) => Network.get('api/Outsource/Order/GetStatusNum',data),
    // 日志
    sys_purchase_order_logOut:(data) => Network.post('api/sys_Outsource_order_log/getPageData',data),
    // 日志 发料
    sys_Material_order_log:(data) => Network.post('api/sys_Material_order_log/getPageData',data),
    // 日志 入库
    sys_Warehousing_order_log:(data) => Network.post('api/sys_Warehousing_order_log/getPageData',data),
    // 订单列表
    getOrderListOut:(data) => Network.get('api/Outsource/Order/GetBuyerOrders',data),
    // 财务确认列表
    GetBuyerOrdersFinanceSureOut:(data) => Network.get('api/Outsource/Order/GetBuyerOrdersFinanceSure',data),
    // 财务付款列表
    GetBuyerOrdersFinancePayOut:(data) => Network.get('api/Outsource/Order/GetBuyerOrdersFinancePay',data),
    // 财务退款列表
    GetBuyerOrdersFinanceReturnPayOut:(data) => Network.get('api/Outsource/Order/GetBuyerOrdersFinanceReturnPay',data),
    // 超期订单
    GetBuyerOrdersOverdueOut:(data) => Network.get('api/Outsource/Order/GetBuyerOrdersOverdue',data),
    // 财务确认
    FinanceSureOrderOut:(data) => Network.post('api/Outsource/Order/FinanceSureOrder',data),
    // 财务撤回
    FinanceBackOrderOut:(data) => Network.post('api/Outsource/Order/FinanceBackOrder',data),
    // 财务付款 撤回
    FinancePayBackOrderOut:(data) => Network.post('api/Outsource/Order/FinancePayBackOrder',data),
    // 订单明细
    getOrdersDetailsOut:(data) => Network.get('api/Outsource/Order/GetBuyerOrderInfo',data),
    // 查询明细
    GetBomPrdtSubListOut:(data) => Network.get('api/Outsource/Order/GetBomPrdtSubList',data),
    // 复制订单 订单明细
    getOrdersDetailsCopyOut:(data) => Network.get('api/Outsource/Order/CopyOrder',data),
    // 同步状态
    AsyncOrderStatusOut:(data) => Network.get('api/Outsource/Order/AsyncOrderStatus',data),
    // 订单取消
    cancelOrderOut:(data) => Network.post('api/Outsource/Order/CancelOrder',data),
    // 订单关闭
    closeOrderOut:(data) => Network.post('api/Outsource/Order/CloseOrder',data),
    // 确认订单
    sureOrderOut:(data) => Network.post('api/Outsource/Order/SureOrder',data),
    //再次  确认订单
    AgainSureOut:(data) => Network.post('api/Outsource/Order/AgainSure',data),
    // 确认付款
    SureOrderPayOut:(data) => Network.post('api/Outsource/Order/SureOrderPay',data),
    // 确认通知
    SureOrderNoticeOut:(data) => Network.post('api/Outsource/Order/SureOrderNotice',data),
    // 订单取消
    CancelOrderOut:(data) => Network.post('api/Outsource/Order/CancelOrder',data),
    // 退款取消
    ReturnPayCancelOrderOut:(data) => Network.post('api/Outsource/Order/ReturnPayCancelOrder',data),
    // 确认退款
    SureReturnPayOut:(data) => Network.post('api/Outsource/Order/SureReturnPay',data),
    // 修改仓库
    UpdateOrderStockOut:(data) => Network.post('api/Outsource/Order/UpdateOrderStock',data),
    // 修改外部单号
    UpdateOrderExternalNoOut:(data) => Network.post('api/Outsource/Order/UpdateOrderExternalNo',data),
    // 再来一单
    BuyAgainOut:(data) => Network.get('api/Outsource/Order/BuyAgain',data),
    // 上传凭证
    UploadPurchaseOut:(data) => Network.post('api/Sys_Outsource_Order/Upload',data),
    // 加工价目表
    getPurveyorInfoOut:(data) => Network.post('api/Sys_Processing_Info/getPageData',data),
    // 新增加工价目表
    AddPurveyorInfoOut:(data) => Network.post('api/Sys_Processing_Info/Add',data),
    // 编辑加工价目表
    updatePurveyorInfoOut:(data) => Network.post('api/Sys_Processing_Info/update',data),
    // 删除加工价目表
    delPurveyorInfoOut:(data) => Network.post('api/Sys_Processing_Info/del',data),
    // 统一调价
    BatchUpdateDiscountOut:(data) => Network.post('api/Sys_Processing_Price/BatchUpdateDiscount',data),
    // 个人中心-价目表列表-移交负责人
    UpdateManagerInfoOut:(data) => Network.post('api/Sys_Processing_Info/UpdateManager',data),
    // 个人中心-价目表列表-移交负责人校验
    UpdateManagerCheckInfoOut:(data) => Network.post('api/Sys_Processing_Info/UpdateManagerCheck',data),

    // 个人中心-价目表-移交负责人
    UpdateManagerOut:(data) => Network.post('api/Sys_Processing_Price/UpdateManager',data),
    // 个人中心-价目表-移交负责人校验
    UpdateManagerCheckOut:(data) => Network.post('api/Sys_Processing_Price/UpdateManagerCheck',data),

    // 加工价目表修改历史
    getPurveyorLogInfoOut:(data) => Network.post('api/Sys_Processing_Log_Info/GetPageData',data),
    // 加工价目表修改历史详细
    getPurveyorPriceLogOut:(data) => Network.post('api/Sys_Processing_Price_Log/GetPageData',data),
    // 加工价目表维护
    getPurveyorPriceOut:(data) => Network.post('api/Sys_Processing_Price/getPageData',data),
    //根据商品编码获取商品信息
    GetPrdtListPurveyorPriceOut:(data) => Network.post('api/Sys_Processing_Price/GetPrdtList ',data),
    // 商品分类档案
    GetItemCategoryListOut:(data) => Network.get('api/Sys_Processing_Price/GetItemCategoryList',data),
    //保存价目表 
    SavePurveyorPriceOut:(data) => Network.post('api/Sys_Processing_Price/Save ',data),
    //新增 保存价目表 
    AddSaveOut:(data) => Network.post('api/Sys_Processing_Price/AddSave ',data),
    //删除价目表 
    DelPurveyorPriceOut:(data) => Network.post('api/Sys_Processing_Price/Del ',data),
    // 供应商价目表维护 导入
    ImportPurveyorPriceOut:(data) => Network.post('api/Sys_Processing_Price/Import',data),
    ExportPurveyorPriceOut:(data) => Network.post('api/Sys_Processing_Price/Export',data),
    DownLoadOut:(data) => Network.get('api/Sys_Processing_Price/DownLoad',data),
    //下载Excel
    ExportErrorOut:(data) => Network.post('api/Sys_Processing_Price/ExportError',data),

    // 委外发料列表
    GetBuyerOrdersMaterial:(data) => Network.get('api/Material/Order/GetBuyerOrders',data),
    // 委外入库列表
    GetBuyerOrdersWarehousing:(data) => Network.get('api/Warehousing/Order/GetBuyerOrders',data),
    // 订单关闭 发料
    closeOrderOutMaterial:(data) => Network.post('api/Material/Order/CloseOrder',data),
    // 订单关闭 入库
    closeOrderOutWarehousing:(data) => Network.post('api/Warehousing/Order/CloseOrder',data),
    // 同步 发料
    AsyncOrderStatusWarehousing:(data) => Network.get('api/Material/Order/AsyncOrderStatus',data),
    // 同步 入库
    AsyncOrderStatusMaterial:(data) => Network.get('api/Warehousing/Order/AsyncOrderStatus',data),
    // 委外发料订单明细
    getOrdersDetailsOutMaterial:(data) => Network.get('api/Material/Order/GetBuyerOrderInfo',data),
    // 委外入库订单明细
    getOrdersDetailsOutWarehousing:(data) => Network.get('api/Warehousing/Order/GetBuyerOrderInfo',data),
    // 查询发料子件
    GetBomPrdtSubListOutMaterial:(data) => Network.get('api/Material/Order/GetBomPrdtSubList',data),
    // 查询入库子件
    GetBomPrdtSubListOutWarehousing:(data) => Network.get('api/Warehousing/Order/GetBomPrdtSubList',data),






    // 注册
    register:(data) => Network.post('api/user/Register',data),
    //  获取注册页面配置
    GetRegisterPageConfig:(data) => Network.get('api/configCg/GetRegisterPageConfig',data),
    //验证公司、手机号
    checkphonecompany:(data) => Network.get('api/user/CheckPhoneOrCompany',data),
    // 找回密码
    modify:(data) => Network.post('api/user/modifyPwd',data),
    // 获取图文验证码
    getVierificationCode:() => Network.get('api/user/GetVierificationCode'),
    // 发送短信
    sendMobileCode:(data) => Network.post('api/user/SendRegisterCode',data),
    // 忘记密码
    forgetPwd:(data) => Network.post('api/user/ForgetPwd',data),
    // 验证短信
    ForgetPwdValidCode:(data) => Network.post('api/user/ForgetPwdValidCode',data),
    // 修改密码
    updatePwd:(data) => Network.post('api/user/UpdatePwd',data),
    // 获取用户信息
    getCurrentUserInfo:(data) => Network.post('api/user/GetCurrentUserInfo',data),
    // 系统配置
    config:() => Network.get('api/configCg/GetSysConfig'),
    // 获取注册协议
    getSysConfigToRegister:() => Network.get('api/user/GetSysConfigToRegister'),
    // 轮播图
    chartlist:(data) => Network.get('api/SysContentConfig/GetSysCarouselChartList',data),
    // 新闻公告
    newslist:(data) => Network.get('api/SysContentConfig/GetNewsList',data),
    // 底部导航信息
    navigationlist:(data) => Network.get('api/SysContentConfig/GetBottomNavigationsList',data),
    // 头部导航分类
    classify:(data) => Network.get('api/MallSlassification/GetMallSlassificationList',data),
    // 分类下拉
    SearchMallSlassificationSelect:(data) => Network.get('api/MallSlassification/SearchMallSlassificationSelect',data),

    
    // 搜索 产品条件查询
    getStandardCondition:(data) => Network.get('api/Standard/GetPrdtBaseInfo',data),
    // 搜索 产品列表查询
    getStandardProduct:(data) => Network.get('api/Standard/GetPrdtList',data),
    // 保存样式
    SavePrdtStyle:(data) => Network.post('api/configCg/SavePrdtStyle',data),
    
    // 产品详情
    getPrdtInfo:(data) => Network.get('api/Prdt/GetPrdtInfo',data),
    // 热词搜索
    getSearchRecordList:(data) => Network.get('api/Prdt/GetSearchRecordList',data),
    // 加入购物车
    // addCart:(data) => Network.post('api/Cart/AddCart',data),
    // 修改购物车数量
    // updateCartQty:(data) => Network.post('api/Cart/UpdateCartQty',data),
    // 修改购物车选中项
    // updateCartCheck:(data) => Network.post('api/Cart/UpdateCartCheck',data),
    // 修改购物车选中项
    delCart:(data) => Network.post('api/Cart/DelCart',data),
    // 批量修改购物车选中项
    DelCartBatch:(data) => Network.post('api/Cart/DelCartBatch',data),
    // 获取购物车产品集合
    // getCartPrdtList:(data) => Network.get('api/Cart/GetCartPrdtList',data),
    // 获取结算页面产品集合
    // getSettlePrdtList:(data) => Network.get('api/Cart/GetSettlePrdtList',data),
    // 重新计算运费 
    CalcFreightAmt:(data) => Network.post('api/Cart/CalcFreightAmt',data),


    // 添加到货通知
    addCollection:(data) => Network.post('api/Collections/AddCollection',data),
    // 删除到货通知
    delCollection:(data) => Network.post('api/Collections/DelCollection',data),
    // 修改到货通知
    updateCollection:(data) => Network.post('api/Collections/UpdateCollection',data),
    // 添加到货通知
    getCollectionList:(data) => Network.get('api/Collections/GetPrdtList',data),
    // 获取服务器时间
    getCurrentDateTime:(data) => Network.get('api/purchase/GetCurrentDateTime',data),
    // 获取收货地址数据
    getUserAddressList:(data) => Network.get('api/BuyerAddress/GetUserAddress',data),
    // 获取收货地址数据 带分页
    getUserAddressListPage:(data) => Network.get('api/BuyerAddress/GetUserAddressPage',data),
    // 获取收货地址数据
    getUserAddressInfo:(data) => Network.get('api/BuyerAddress/GetUserAddressInfo',data),
    // 新增收货地址数据
    addBuyerAddress:(data) => Network.post('api/BuyerAddress/AddBuyerAddress',data),
    // 修改收货地址数据
    uptBuyerAddress:(data) => Network.post('api/BuyerAddress/UptBuyerAddress',data),
    // 删除收货地址数据
    delBuyerAddress:(data) => Network.post('api/BuyerAddress/DelBuyerAddress',data),
    // 设置默认收货地址
    setBuyerAddressDefault:(data) => Network.post('api/BuyerAddress/UptBuyerAddressDefault',data),
   
    // 退货列表
    getReturnOrderList:(data) => Network.get('api/Order/GetBuyerReturnOrders',data),
    // 退货详情
    getReturnOrderDetail:(data) => Network.get('api/Order/GetReturnOrderDetail',data),
    // 申请退货
    applyReturnOrder:(data) => Network.post('api/Order/ApplyReturnOrder',data),
    // 获取退货原因
    getReturnReasonList:(data) => Network.get('api/Order/GetReturnReasonList',data),
    // 获取站内消息
    getMessageList:(data) => Network.get('api/Message/GetMessageList',data),
    // 设置为已读
    setRead:(data) => Network.post('api/Message/UpdateIsRead',data),
    // 删除站内消息
    delMessage:(data) => Network.post('api/Message/DelMessage',data),
    // 对账列表
    getAccountList:(data) => Network.get('api/Account/GetAccountList',data),
    // 对账明细
    getAccountInfo:(data) => Network.get('api/Account/GetAccountInfo',data),
    // 获取开票信息
    getInvoInfo:() => Network.get('api/user/GetInvoInfo'),
    // 更新开票信息
    updateInvo:(data) => Network.post('api/user/UpdateInvo',data),
    // 更新收票信息
    updateReceipt:(data) => Network.post('api/user/UpdateReceipt',data),
    // 刷新taoken
    replaceToken:(data) => Network.post('api/user/replaceToken',data),
    //判断背景色是否变更
    changeColor:(data) => Network.get('api/configCg/IfColorChange',data),
    // 获取广告位
    GetAdvertisement:(data) => Network.get('api/SysContentConfig/GetAdvertisement',data),
    
    //获取支付方式
    GetPaymentList:(data) => Network.post('api/Pay/GetPayInfo',data),
    //提交支付
    PayOrder:(data) => Network.post('api/Pay/ToOrder',data),
    //获取支付状态
    GetOrderPayStatus:(data) => Network.get('api/Pay/GetOrderPayStatus',data),
    
    //多个订单支付
    ToOrderList:(data) => Network.post('api/Pay/ToOrderList',data),
    //订单通知接口
    NotifyOrder:(data) => Network.get('api/Pay/NotifyOrder',data),

    //对账单支付
    ToPyaAccountInfo:(data) => Network.post('api/Pay/ToPyaAccountInfo',data),
    //对账单支付状态查询
    NotifyAccountInfo:(data) => Network.get('api/Pay/NotifyAccountInfo',data),
    
    
    //非标定制品相关接口
    AddCustomized:(data) => Network.post('api/customized/AddCustomized',data),
    //上传文件
    UploadForApi:(data) => Network.post('api/customized/UploadForApi',data),
    //获取非标订制品
    GetCustomizedList:(data) => Network.get('api/customized/GetCustomizedList',data),
    //获取非标订制品 详情
    GetCustomizedDetail:(data) => Network.get('api/customized/GetCustomizedDetail',data),

    //保存产品自定义编码
    SavePrdtCustom:(data) => Network.post('api/Prdt/Custom/SavePrdtCustom',data),
    //自定义编码查询
    GetPrdtCustomList:(data) => Network.get('api/Prdt/Custom/GetPrdtCustomList',data),
    //删除产品自定义编码
    DelPrdtCustom:(data) => Network.post('api/Prdt/Custom/DelPrdtCustom',data),
    //下载导入Excel模板
    DownLoadPrdtCustom:(data) => Network.get('api/Prdt/Custom/DownLoadPrdtCustom',data),
    //导入表数据Excel文件夹
    ImportPrdtCustom:(data) => Network.post('api/Prdt/Custom/ImportPrdtCustom',data),
    //导出文件，返回日期+文件名
    ExportPrdtCustom:(data) => Network.post('api/Prdt/Custom/ExportPrdtCustom',data),

    //导出我的物料，用来添加购物车
    ExportMyPrdtCustom:(data) => Network.post('api/Prdt/Custom/ExportMyPrdtCustom',data),
    //导入表数据Excel文件夹
    ImportCartPrdt:(data) => Network.post('api/Prdt/Custom/ImportCartPrdt',data),
    //自定义编码购物车， 快速下单导入和查询后调用这个接口  返回所有自定义编码购物车的数据
    GetCartPrdtCustomList:(data) => Network.get('api/Prdt/Custom/GetCartPrdtCustomList',data),
    // 新增自定义编码到购物车，数量累加
    GetAddCartPrdtCustomList:(data) => Network.get('api/Prdt/Custom/GetAddCartPrdtCustomList',data),
    // 删除产品自定义编码
    DelCartPrdtCustom:(data) => Network.post('api/Prdt/Custom/DelCartPrdtCustom',data),
    // 编辑自定义编码购物车数量
    UpdateCartPrdtCustom:(data) => Network.post('api/Prdt/Custom/UpdateCartPrdtCustom',data),

    // 充值获取支付方式
    GetRechargePayInfo:(data) => Network.post('api/Pay/GetRechargePayInfo',data),
    // 充值
    ToRecharge:(data) => Network.post('api/Pay/ToRecharge',data),
    // 获取转入记录
    GetSurplusCheckPage:(data) => Network.get('api/user/GetSurplusCheckPage',data),
    // 充值-查询支付状态
    GetRechargePayStatus:(data) => Network.get('api/Pay/GetRechargePayStatus',data),
    // 设置支付密码
    SetPayPwd:(data) => Network.post('api/user/SetPayPwd',data),
    // 获取余额流水
    GetSurplusPage:(data) => Network.get('api/user/GetSurplusPage',data),
    // 校验支付密码是否正确
    CheckPayPwd:(data) => Network.post('api/user/CheckPayPwd',data),
    // 余额提现
    ToWithdrawal:(data) => Network.post('api/Pay/ToWithdrawal',data),
    
    // 校验支付密码是否正确
    CheckPayPwd:(data) => Network.post('api/user/CheckPayPwd',data),
    // 提现申请记录
    GetWithdrawalCheckPage:(data) => Network.get('api/user/GetWithdrawalCheckPage',data),

    // 货拉拉
    GetAccoutToken:(data) => Network.get('api/HuoLaLa/GetAccoutToken',data),
    GetUCityInfo:(data) => Network.get('api/HuoLaLa/GetUCityInfo',data),
    GetUOrderCalculate:(data) => Network.post('api/HuoLaLa/GetUOrderCalculate',data),
    GetUOrderRequest:(data) => Network.get('api/HuoLaLa/GetUOrderRequest',data),
    GetOrderCashier:(data) => Network.get('api/HuoLaLa/GetOrderCashier',data),
    GetOrderPayStatusForHll:(data) => Network.get('api/HuoLaLa/GetOrderPayStatus',data),

    // 埋点
    AddBuyerAct:(data) => Network.post('api/user/AddBuyerAct',data),
    // 自定义商品导出
    ExportPrdtList:(data) => Network.post('api/Prdt/ExportPrdtList',data),
    // 自定义商品导入
    ImportPrdtCustom:(data) => Network.post('api/Prdt/ImportPrdtCustom',data),

    // 投诉反馈=========
    //获取下拉框的值
    GetComplaintEnum:(data) => Network.get('api/Complaint/GetComplaintEnum',data),
    //分页获取数据
    GetComplaintPage:(data) => Network.get('api/Complaint/GetComplaintPage',data),
    //分页获取数据 详情
    GetComplaintInfo:(data) => Network.get('api/Complaint/GetComplaintInfo',data),
    //新增投诉反馈
    AddComplaint:(data) => Network.post('api/Complaint/AddComplaint',data),
    //删除投诉反馈
    DelComplaint:(data) => Network.post('api/Complaint/DelComplaint',data),


    //保存头像
    SetHeadImageUrl:(data) => Network.post('api/user/SetHeadImageUrl',data),

    //首页广告模块 SourceType（1电脑端,2微信端,3小程序,4安卓端,5苹果端,6代理端）
    GetAdverModule:(data) => Network.get('api/SysContentConfig/GetAdverModule',data),

    //获取首页配置
    GetHomeTemplate:(data) => Network.get('api/purchase/GetHomeTemplate',data),
    //获取库存信息
    GetInventData:(data) => Network.get('api/purchase/GetInventData',data),
    //获取库存信息（主管页专用：无任务栏/购物车/缺货订单，含可售天数）
    GetInventDataManager:(data) => Network.get('api/purchase/GetInventDataManager',data),
    //获取子商品信息
    GetSubPrdtData:(data) => Network.get('api/purchase/GetSubPrdtData',data),

    //价目表引用报表
    GetPriceReport:(data) => Network.post('api/report/GetPriceReport',data),
    //价目表引用报表-详情
    GetPriceDetailReport:(data) => Network.post('api/report/GetPriceDetailReport',data),
    // 价目表引用报表导出主表
    ExportPrice:(data) => Network.post('api/report/ExportPrice',data),
    // 价目表引用报表导出明细
    ExportPriceDetail:(data) => Network.post('api/report/ExportPriceDetail',data),

	//销售报表
	GetProfitData:(data) => Network.post('api/report/Profit/GetPageData',data),
	ExportProfit:(data) => Network.post('api/report/ExportProfit',data),  //明细表
	ExportProfitOrder:(data) => Network.post('api/report/ExportProfitOrder',data),  //主表
	DownLoadTemplateProfit:(data) => Network.get('api/report/DownLoadTemplateProfit',data),  //下载模版
	
	//预警报表
	GetWarningData:(data) => Network.post('api/report/Warning/GetPageData',data),
	GetWarningPrdtLogList:(data)=> Network.post('api/report/Warning/GetPrdtLogList',data),
	//预警/缺货时效报表
	GetTimelinessReport:(data) => Network.post('api/Sys_Prdt_Warning_Log/TimelinessReport',data),
	GetTimelinessSummary:(data) => Network.post('api/Sys_Prdt_Warning_Log/TimelinessSummary',data),
	ExportTimeliness:(data) => Network.post('api/Sys_Prdt_Warning_Log/TimelinessExport',data),
    //任务中心-查询
    GetDataPageTask:(data) => Network.get('api/Sys_Task_Info/GetDataPage',data),
    //任务中心-详情
    GetTaskInfo:(data) => Network.get('api/Sys_Task_Info/GetTaskInfo',data),
    //任务中心-已读
    ReadTaskInfo:(data) => Network.post('api/Sys_Task_Info/Read',data),

    //我的订单--查询table
    GetWorkOrder:(data) => Network.post('api/open/GetWorkOrder',data),
    //我的订单--上传
    SysUpload:(data) => Network.post('api/Sys_Config/Upload',data,'正在处理...'),
    //我的订单--创建
    AddWorkOrder:(data) => Network.post('api/open/AddWorkOrder',data),
    //我的订单--删除
    SysDeleteWorkOrder:(data) => Network.post('api/Sys_WorkOrder/DeleteWorkOrder',data),
    //我的订单--删除
    DeleteWorkOrder:(data) => Network.post('api/open/DeleteWorkOrder',data),
     //我的订单--关闭
    CloseWorkOrder:(data) => Network.post('api/open/CloseWorkOrder',data),
     //我的订单--流转工单
    SaveWorkOrder:(data) => Network.post('api/Sys_WorkOrder/SaveWorkOrder',data),
	//采购订单--导入
	PurchaseImportOrder:(data)=>Network.post('api/purchase/order/importOrder',data),
	//采购订单--下载导入模板
	PurchaseDownloadImportTemplate:()=>Network.get('api/Purchase/Order/DownloadImportTemplate'),
    //商品报告--列表
	GetReportData:(data) => Network.post('api/Prdt_Report/getPageData',data),
    //商品报告--新增
	GetReportAdd:(data) => Network.post('api/Prdt_Report/Add',data),
    //商品报告--修改
	GetReportUpdate:(data) => Network.post('api/Prdt_Report/update',data),
    //商品报告--删除
	GetReportDel:(data) => Network.post('api/Prdt_Report/del',data),
    //商品报告--上传
	GetReportUpload:(data) => Network.post('api/Prdt_Report/Upload',data),
	
	// 开单详情列表
	GetPurchaseOrderByOrderClerkReport:(data) => Network.get('api/Purchase/Order/GetPurchaseOrderByOrderClerkReport',data),
	// 开单列表
	GetPurchaseOrderByOrderClerkSummaryReport:(data) => Network.get('api/Purchase/Order/GetPurchaseOrderByOrderClerkSummaryReport',data),
	// 开单导出
	PurchaseOrderExportSummaryReport:(data) => Network.post('api/Purchase/Order/ExportSummaryReport?'+data,{}),
	// 开单详情导出
	PurchaseOrderExportReport:(data) => Network.post('api/Purchase/Order/ExportReport?'+data,{}),
	
	// 询价详情列表
	GetSysPurveyorPriceLogReport:(data) => Network.get('api/Sys_Purveyor_Price_Log/GetReport',data),
	// 询价列表
	GetSysPurveyorPriceSummaryLogReport:(data) => Network.get('api/Sys_Purveyor_Price_Log/GetReportSummary',data),
	// 询价导出
	SysPurveyorPriceLogSummaryExportReport:(data) => Network.post('api/Sys_Purveyor_Price_Log/ExportSummaryReport?'+data,{}),
	// 询价详情导出
	SysPurveyorPriceLogExportReport:(data) => Network.post('api/Sys_Purveyor_Price_Log/ExportReport?'+data,{}),
	// 获取商品分类
	getSysCategoryData:(data) => Network.get('/api/SysPrdtController/GetItemCategoryList',data),

	// ===== 采购员考核 =====
	// 配置（单记录 JSON，存 Sys_Config.buyerAssessConfig）
	getBuyerAssessConfig: (data) => Network.get('api/sysConfigController/GetBuyerAssessConfig', data),
	saveBuyerAssessConfig: (data) => Network.post('api/sysConfigController/SaveBuyerAssessConfig', data),
	// 主报表（读快照表）+ 生成/重新生成/导出
	getPurchaserAssessReport: (data) => Network.post('api/Purchase/Assess/GetReport', data),
	// 数据权限范围（非超管按授权类型限定可见采购员；buyerIds=null 表示不限）
	getAssessBuyerScope: (data) => Network.post('api/Purchase/Assess/GetBuyerScope', data),
	refreshAssessSnapshot: (data) => Network.post('api/Purchase/Assess/RefreshSnapshot', data),
	refreshBuyerSnapshot: (data) => Network.post('api/Purchase/Assess/RefreshBuyerSnapshot', data),
	// 保存主管打分/满勤/违规（超管或报表按钮权限用户）
	saveAssessManual: (data) => Network.post('api/Purchase/Assess/SaveAssessManual', data),
	exportPurchaserAssessReport: (data) => Network.post('api/Purchase/Assess/ExportReport', data),
	// 6 维度明细（实时查活表）+ 导出(Dimension: warning/stockout/delivery/accuracy/costadjust/pricediff)
	getAssessWarningDetail: (data) => Network.post('api/Purchase/Assess/GetWarningDetail', data),
	getAssessStockoutDetail: (data) => Network.post('api/Purchase/Assess/GetStockoutDetail', data),
	getAssessDeliveryDetail: (data) => Network.post('api/Purchase/Assess/GetDeliveryDetail', data),
	getAssessAccuracyDetail: (data) => Network.post('api/Purchase/Assess/GetAccuracyDetail', data),
	getAssessCostAdjustDetail: (data) => Network.post('api/Purchase/Assess/GetCostAdjustDetail', data),
	getAssessPriceDiffDetail: (data) => Network.post('api/Purchase/Assess/GetPriceDiffDetail', data),
	exportAssessDetail: (data) => Network.post('api/Purchase/Assess/ExportAssessDetail', data),
	// 考核豁免（申请+审批；数据存独立表 Sys_Assess_Exempt，审批通过后对应明细按达标计算并自动重算当月快照）
	applyAssessExempt: (data) => Network.post('api/Purchase/Assess/ApplyExempt', data),
	getAssessExemptList: (data) => Network.post('api/Purchase/Assess/GetExemptList', data),
	approveAssessExempt: (data) => Network.post('api/Purchase/Assess/ApproveExempt', data),
}
